import request from '../../utils/request';

export function getUsers(params) {
  return request(`/users`, {
    method: 'GET',
    params,
  });
}

export function createUser(params) {
  return request(`/users`, {
    method: 'POST',
    data: params,
  });
}
export function doGetInvite(params) {
  return request(`/invite`, {
    method: 'GET',
    data: params,
  });
}

export function updateUser(params) {
  const { id } = params;
  return request(`/users/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function deleteUser(params) {
  const { id } = params;
  return request(`/users/${id}`, {
    method: 'DELETE',
  });
}
